import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Fail loudly in dev so misconfigured deploys are obvious.
  console.warn(
    '[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY — auth will not work. Check .env.'
  );
}

let _client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (_client) return _client;
  _client = createClient(url ?? '', anonKey ?? '', {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // No-op navigator-locks shim. supabase-js v2 wraps token refresh in
      // `navigator.locks.request(...)` which deadlocks across tabs on Safari
      // and on Chrome under certain extension load orders (most painfully
      // 1Password). Replacing the lock with a pass-through is the official
      // workaround when you don't need cross-tab refresh coordination —
      // and on a fork-per-client admin we don't (one tab is the norm).
      // Saves the multi-hour debugging session Aiden has paid for already.
      lock: async (_name, _acquireTimeout, fn) => fn(),
    },
  });
  return _client;
}
